export interface RegulationsOption {
    label: string;
    value: string | boolean;
}

export function regulationsOptionsData(): RegulationsOption[] {
    return [
        {
            value: true,
            label: "yes",
        },
        {
            value: false,
            label: "no",
        },
        {
            value: "not_specified",
            label: "not_specified",
        },
    ];
}

